<div class="join-us-container mat-elevation-z0" id="joinUs">
  <div fxLayout="row wrap">
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="0" class="join"></div>
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="row-container">
      <div class="content" style="text-align: center">
        <h1 class="Join-title">
          Offer your customers a<br /><span>flexible interest free<br /></span
          >payment option.
        </h1>
        <br />
        <p class="info-paragraph">
          Zero risk, boost in sales, increase in basket size, upfront payment,
          greater customer loyalty…
        </p>
        <br />
        <button
          mat-stroked-button
          [routerLink]="['/merchant/signup']"
          (click)="scrollTo('top')"
        >
          JOIN US
        </button>
      </div>
    </div>
  </div>
</div>
<div fxLayout="row wrap" fxLayoutAlign="stretch">
  <div fxFlex.gt-sm="100" fxFlex.lt-sm="100">
    <br />
    <br />
    <h2 style="text-align: center; color: #1a2759">
      ZeroPay let’s your customers
      <strong
        >buy now and pay later in 3 x Zero fee, Zero interest
        instalments.</strong
      >
      <br />
      <br />
      <strong>Why ZeroPay?</strong>
    </h2>
    <br />
  </div>
  <div fxFlex.gt-sm="20" fxFlex.lt-sm="100"></div>
  <div fxFlex.gt-sm="30" fxFlex.lt-sm="100" style="padding-left: 12px">
    <ol
      style="
        border-radius: 24px;
        background: #fff;
        list-style: none;
        padding-left: 0;
        height: 448px;
      "
      [ngStyle.lt-sm]="{ height: 'auto' }"
    >
      <li>
        <strong>1.</strong> <strong> 80% of customers</strong> that are approved
        <strong>spend on the same day</strong> - lower cart abandonment.
      </li>
      <li>
        <strong>2.</strong> <strong> Monthly marketing opportunities</strong> -
        we drive traffic to your store.
      </li>
      <li>
        <strong>3.</strong> <strong> Seamless application</strong> during
        checkout – customers don’t need to leave your site.
      </li>
      <li>
        <strong>4.</strong> Focus on <strong>repeat spend</strong> - customers
        spend up to 2.4x per month.
      </li>
      <li>
        <strong>5.</strong> <strong> Larger average invoice values</strong> –
        current average invoice value of R3 500.
      </li>
    </ol>
  </div>
  <div fxFlex.gt-sm="30" fxFlex.lt-sm="100" style="padding-left: 12px">
    <ol
      start="6"
      style="
        border-radius: 24px;
        background: #fff;
        list-style: none;
        padding-left: 0;
        height: 448px;
      "
      [ngStyle.lt-sm]="{ height: 'auto' }"
    >
      <li>
        <strong>6.</strong> Our list of Merchants differ from others –
        <strong>we bring you new customers.</strong>
      </li>
      <li>
        <strong>7.</strong> <strong> Upfront settlement</strong> – zero risk to
        you.
      </li>
      <li>
        <strong>8.</strong> <strong> No fixed fees</strong> - only per
        transaction.
      </li>
      <li>
        <strong>9.</strong>
        <strong> ZeroPay handles any missed payments</strong> by the customer.
      </li>
      <li>
        <strong>10.</strong> <strong> Easy</strong> plug-and-play
        <strong>onboarding</strong> – plugins available for most ecommerce
        sites.
      </li>
    </ol>
  </div>
</div>
<br />
<br />
<app-benefits title="Benefits to <span>your customers</span>"></app-benefits>
<div style="background: #1a2759; color: #fff">
  <div fxFlex="row wrap">
    <div
      fxFlex="70"
      style="padding: 64px"
      fxFlex.lt-sm="100"
      [ngStyle.lt-sm]="{ padding: '16px' }"
    >
      <h2
        style="color: #f2f2f2"
        [ngStyle.lt-sm]="{ fontSize: '12px', textAlign: 'center' }"
      >
        “ZeroPay has improved both our online and in store shopping experience
        by giving our customers a flexible payment option. The registration
        process for customers are seamless and user-friendly. The implementation
        was simple, and both their management and support team are incredibly
        helpful and accommodating. They go over and above what is expected when
        it comes to customer service – this being one of the main reasons we
        chose ZeroPay as our BNPL product.”
      </h2>
      <br />
      <h1 [ngStyle.lt-sm]="{ fontSize: '14px', textAlign: 'center' }">
        <strong>~ Ryan Kaplan, Financial Director at Decofurn SA</strong>
      </h1>
    </div>
    <div fxFlex="30" [ngStyle.lt-sm]="{ display: 'none' }">
      <img src="/assets/app.png" style="width: 100%; height: auto" />
    </div>
  </div>
</div>
<div fxLayout="row wrap" fxLayoutAlign="stretch">
  <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="half-1" id="howItWorks">
    <div class="how-it-works-join">
      <div class="content">
        <div fxLayout="row wrap">
          <div fxFlex="30" fxFlex.lt-sm="100">
            <img
              src="/assets/product.jpg"
              style="
                width: 80%;
                margin-left: auto;
                margin-right: auto;
                display: block;
              "
            />
            <div style="color: #1a2759; font-size: 22px">
              <strong>R999.67</strong> x 3
              <img
                src="/assets/final/logo.png"
                style="width: 128px; height: auto; vertical-align: middle"
              />
            </div>
          </div>
          <div fxFlex="70" fxFlex.lt-sm="100" style="padding: 16px">
            <h2
              [ngStyle.lt-sm]="{ marginTop: '24px', marginBottom: '24px' }"
              style="
                font-size: 36px;
                line-height: 42px;
                margin-top: 82px;
                margin-bottom: 82px;
              "
            >
              Displaying the instalment calculator widget
              <strong>improves conversion by up to 30%</strong>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="half-2">
    <div class="how-it-works-partner">
      <div class="content">
        <h1>Interest in joining but still have <br />some questions?</h1>
        <br />
        <p class="info-paragraph">
          Read through our Frequently Asked Questions.
        </p>
        <a
          mat-stroked-button
          [routerLink]="['/merchant-faq']"
          (click)="scrollTo('top')"
          class="btn-action"
          >READ MORE</a
        >
      </div>
    </div>
  </div>
  <div fxFlex="100">
    <div class="how-it-works-contact">
      <div class="content">
        <h1>Contact us, we would love <br />to have you as a spend partner.</h1>
        <a mat-stroked-button class="btn-action" (click)="contact()"
          >CONTACT US</a
        >
      </div>
    </div>
  </div>
</div>
<div style="padding: 16px" [ngStyle.lt-sm]="{ padding: '12px' }">
  <br />
  <br />
  <h1 style="text-align: center; color: #1a2759">
    <strong>Offer ZeroPay online or in-store.</strong>
  </h1>
  <br />
  <img
    src="/assets/merchant_benefit_flow 1.svg"
    style="
      margin-left: auto;
      margin-right: auto;
      display: block;
      width: 100%;
      max-width: 900px;
      height: auto;
    "
  />
  <br />
</div>
